module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Tablet@2x.fa6e0452.jpg";